import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import CardChoice from 'features/CardChoice';
import ProductChoice from 'features/ProductChoice';
import DriverLicenseStart from 'features/DriverLicense/DriverLicenseStart';
import ConsumerSearch from 'features/ConsumerSearch/ConsumerSearch';
import { RouteComponentProps } from 'react-router';

import { selectCreditApplication } from 'state/creditApplication';
import LoyaltyNumberError from 'features/Home/LoyaltyNumberError';

import useStartPageName from 'features/Home/useStartPageName';
import { useTrackApplicationStart } from 'hooks/useAnalytics';
import useLoadInitialData from 'hooks/useLoadInitialData';
import useWorkflow, { Step } from 'hooks/useWorkflow';
import useFieldCustomization from 'hooks/useFieldCustomization';

const initialDataKeys = [
  'firstName',
  'lastName',
  'address1',
  'address2',
  'city',
  'state',
  'zip',
  'emailAddress',
  'mobilePhone',
  'alternativePhone',
  'storeNumber',
  'category',
  'cardType',
  'cartAmount',
  'checkoutAmount',
  'correlationData',
  'customerNumber',
  'loyaltyNumber',
  'productAmount',
  'sku',
  'clientVariable1',
  'clientVariable2',
  'clientVariable3',
  'clientVariable4',
  'associateId',
];

const DriverLicenseHome: React.FC<RouteComponentProps> = props => {
  const { steps } = useWorkflow();

  useLoadInitialData(initialDataKeys);

  const startPageName = useStartPageName();
  useTrackApplicationStart(startPageName);

  const creditApplication = useSelector(selectCreditApplication);
  const { isRequired } = useFieldCustomization();

  const Component = useMemo(() => {
    switch (steps[0]) {
      case Step.CARD_CHOICE:
        return CardChoice;
      case Step.PRODUCT_CHOICE:
        return ProductChoice;
      case Step.CONSUMER_SEARCH:
        return ConsumerSearch;
      case Step.DRIVER_LICENSE_START:
        return DriverLicenseStart;
      default:
        //not supposed to happen
        throw new Error(`Unexpected start route ${steps[0]}`);
    }
  }, [steps]);

  if (isRequired('loyaltyNumber') && !creditApplication.loyaltyNumber) {
    return <LoyaltyNumberError />;
  } else {
    return <Component {...props} />;
  }
};

export default DriverLicenseHome;
